/**
 * Utility functions for payroll operations
 */

/**
 * Opens the RollFi payroll dashboard via SSO initiation
 * Opens in a new tab with security features
 */
export const openPayrollDashboard = () => {
  window.open("/sso/initiate-payroll", "_blank", "noopener,noreferrer");
};
